export async function loadCompleteMatchHistory(loadPage, userId) {
  const rows = new Map();
  const seenTokens = new Set();
  let nextToken;
  try {
    do {
      const page = await loadPage(userId, {
        limit: 25,
        statuses: ["pending", "confirmed", "cancelled", "withdrawn"],
        includeScores: true,
        ...(nextToken ? { nextToken } : {}),
      });
      for (const item of page.data || []) {
        const registration = item.registration || {};
        // Defense in depth for older API responses and legacy uploader-owned rosters.
        // Names, emails, membership numbers and match ownership are not account links.
        if (registration.userId !== userId || registration.source !== "self_service") continue;
        const key = registration.registrationId;
        if (!key) throw new Error("A match registration is missing its identity. Retry loading history.");
        rows.set(key, item);
      }
      nextToken = page.nextToken || page.meta?.nextToken;
      if (nextToken && (seenTokens.has(nextToken) || seenTokens.size >= 199)) {
        throw new Error("Match history pagination did not finish. Retry loading history.");
      }
      if (nextToken) seenTokens.add(nextToken);
    } while (nextToken);
    return { data: [...rows.values()], error: null };
  } catch (error) {
    if (!rows.size) throw error;
    return { data: [...rows.values()], error };
  }
}
